
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IAutoCreatePOResult, ICreatePurchaseOrdersFromRequisitionsCriteria, IDocument, IPurchaseOrderEmailCriteria, IPurchaseOrderInvoice, IPurchaseOrderItem, IPurchaseOrderNoticeCriteria, Tuple } from "@tylertech/tyler-api-types";

/**
 * PurchaseOrderService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PurchaseOrderService {
    constructor(private readonly $apiService: ApiService) { }
    
    AutoCreatePurchaseOrderFromApprovedReq(id: string): Promise<IAutoCreatePOResult> {
        return this.$apiService.sendAuth("IPurchaseOrderService/AutoCreatePurchaseOrderFromApprovedReq", id);
    }
    CreatePurchaseOrdersFromRequisitions(criteria: ICreatePurchaseOrdersFromRequisitionsCriteria, fromWeb: boolean): Promise<Tuple<{ [key: string]: string }, string>> {
        return this.$apiService.sendAuth("IPurchaseOrderService/CreatePurchaseOrdersFromRequisitions", criteria);
    }
    EmailPurchaseOrderNotices(noticeCriteria: IPurchaseOrderNoticeCriteria): Promise<boolean> {
        return this.$apiService.sendAuth("IPurchaseOrderService/EmailPurchaseOrderNotices", noticeCriteria);
    }
    ExportPurchaseOrderForm(purchaseOrderIds: string[]): Promise<IDocument> {
        return this.$apiService.sendAuth("IPurchaseOrderService/ExportPurchaseOrderForm", purchaseOrderIds);
    }
    GetItems(pPoId: string): Promise<IPurchaseOrderItem[]> {
        return this.$apiService.sendAuth("IPurchaseOrderService/GetItems", pPoId);
    }
    GetPOEmailCriteria(purchaseOrderIds: string[]): Promise<IPurchaseOrderEmailCriteria[]> {
        return this.$apiService.sendAuth("IPurchaseOrderService/GetPOEmailCriteria", purchaseOrderIds);
    }
    GetPoInvoiceItems(pPoId: string): Promise<IPurchaseOrderInvoice[]> {
        return this.$apiService.sendAuth("IPurchaseOrderService/GetPoInvoiceItems", pPoId);
    }
    GetPoInvoices(pPoId: string): Promise<IPurchaseOrderInvoice[]> {
        return this.$apiService.sendAuth("IPurchaseOrderService/GetPoInvoices", pPoId);
    }
    GetUncompletedPOsRelatedToWorkOrder(workOrderIdString: string): Promise<string[]> {
        return this.$apiService.sendAuth("IPurchaseOrderService/GetUncompletedPOsRelatedToWorkOrder", workOrderIdString);
    }
}
